import './dom.css';

/*******************************************************************************
 * @ngdoc    component
 * @module   csm.books.dom
 * @name     csm.books.dom.component:monthSelector
 * @requires select, ngModel
 * @description
 * Month selector dropdown box. Used with `select` and `ngModel` to select the
 * index of the month (1-12) from the month name (January-December) or the short
 * name (Jan-Dec) if <b>short-month-name</b> attribute is used.
 *******************************************************************************/
/* @ngInject */ export function MonthSelectorDirective($compile, Tools) {
  var months = [
    { long: 'January', short: 'Jan' },
    { long: 'February', short: 'Feb' },
    { long: 'March', short: 'Mar' },
    { long: 'April', short: 'Apr' },
    { long: 'May', short: 'May' },
    { long: 'June', short: 'Jun' },
    { long: 'July', short: 'Jul' },
    { long: 'August', short: 'Aug' },
    { long: 'September', short: 'Sep' },
    { long: 'October', short: 'Oct' },
    { long: 'November', short: 'Nov' },
    { long: 'December', short: 'Dec' }
  ];

  return {
    restrict: 'A',
    require: { select: '', ngModel: '' },
    scope: {},
    link: function (scope, element, attrs, ctrls) {
      scope.months = months;
      scope.useShortName =
        attrs.hasOwnProperty('shortMonthName') &&
        (Tools.isEmpty(attrs.shortMonthName) ||
          scope.$eval(attrs.shortMonthName));
      var options =
        '<option ng-value="$index+1" ng-repeat="month in months" ng-bind="useShortName ? month.short : month.long"></option>';
      element.append($compile(options)(scope));

      ctrls.ngModel.$parsers.push(function (val) {
        return parseInt(val);
      });
    }
  }
}
